import React from "react";
import { Instagram, Twitter, Facebook, Youtube, Globe, Link as LinkIcon, Image as ImageIcon, Music2 } from "lucide-react";
import { normalizeImageUrl } from "@/lib/imageUrl";

const ICONS = { instagram: Instagram, twitter: Twitter, x: Twitter, facebook: Facebook, youtube: Youtube, tiktok: Music2, website: Globe };
const LABELS = { instagram: "Instagram", twitter: "X / Twitter", x: "X / Twitter", facebook: "Facebook", youtube: "YouTube", tiktok: "TikTok", website: "Website" };
const withHttp = (u) => (!u ? u : /^https?:\/\//i.test(u) ? u : `https://${u}`);

export default function TeamMediaTab({ team = {} }) {
  const photo = team.primary_photo_url;
  const social = team.social || {};
  const links = [];
  if (team.website) links.push(["website", team.website]);
  Object.entries(social).forEach(([k, v]) => { if (v) links.push([k.toLowerCase(), v]); });

  const hasAny = photo || links.length > 0;
  if (!hasAny) return <div className="py-12 text-center text-sm text-slate-400" data-testid="media-empty">No media linked yet.</div>;

  return (
    <div className="space-y-6" data-testid="team-media-tab">
      {photo && (
        <div data-testid="media-team-photo">
          <div className="label-overline text-[#E63946] mb-2 flex items-center gap-2"><ImageIcon className="w-4 h-4" /> Team Photo</div>
          <div className="rounded-sm overflow-hidden border border-slate-200 bg-slate-100">
            <img src={normalizeImageUrl(photo)} alt={`${team.name} team photo`} className="w-full max-h-[520px] object-cover" />
          </div>
        </div>
      )}

      {links.length > 0 && (
        <div data-testid="media-links">
          <div className="label-overline text-[#E63946] mb-2 flex items-center gap-2"><Globe className="w-4 h-4" /> Channels & Links</div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {links.map(([key, url]) => {
              const Icon = ICONS[key] || LinkIcon;
              return (
                <a key={key} href={withHttp(url)} target="_blank" rel="noreferrer" data-testid={`media-link-${key}`}
                  className="flex items-center gap-3 bg-white border border-slate-200 rounded-sm p-3 hover:border-[#E63946] hover:shadow-sm transition-all focus-visible:ring-2 focus-visible:ring-[#E63946] focus-visible:outline-none">
                  <span className="w-9 h-9 grid place-items-center rounded-sm bg-[#0A192F] text-white shrink-0"><Icon className="w-4 h-4" /></span>
                  <div className="min-w-0">
                    <div className="text-sm font-semibold text-[#0A192F]">{LABELS[key] || key}</div>
                    <div className="text-[11px] text-slate-400 truncate">{url.replace(/^https?:\/\//i, "")}</div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
